import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'se-timeline-toggle',
    templateUrl: './se-timeline-toggle.component.html',
    styleUrls: ['./se-timeline-toggle.component.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule, NgIf],
})
export class SeTimelineToggleComponent implements OnChanges {
    @Input() toggleOpen? : boolean;
    @Output() toggleTimeline : EventEmitter<boolean> = new EventEmitter<boolean>();

    tooltip : string = ''
    constructor (private translate : TranslateService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.toggleOpen) {
            this.tooltip = this.toggleOpen ? this.translate.instant('HideTimeline') : this.translate.instant('ShowTimeline');
        }
    } 

    _showHideTimeline () {
        this.toggleOpen = !this.toggleOpen
        this.toggleTimeline.emit(this.toggleOpen);
    }
}
